import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-notification-item-preloader',
    templateUrl: './notification-item-preloader.component.html',
    styleUrls: ['./notification-item-preloader.component.scss'],
    standalone: true
})
export class NotificationItemPreloaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
